var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.63841 8.18263C1.80725 7.61089 1.97261 6.93434 2.21365 6.28457C2.35338 5.90729 2.29283 5.68371 1.97843 5.45315C1.54176 5.13409 1.08995 4.81619 0.730132 4.41911C0.515872 4.18389 0.299284 3.73674 0.388947 3.49803C0.482103 3.24651 0.922267 3.02642 1.239 2.97868C1.78862 2.89484 2.36037 2.93909 2.92047 2.96005C3.24536 2.97169 3.3979 2.85408 3.49921 2.53968C3.68086 1.97259 3.87416 1.39852 4.15363 0.876839C4.28405 0.633468 4.62873 0.359821 4.8721 0.363314C5.11896 0.366808 5.45782 0.645113 5.58708 0.890813C5.86189 1.41249 6.04121 1.98657 6.23218 2.549C6.33466 2.85292 6.49768 2.97519 6.82489 2.96121C7.38616 2.93909 7.95791 2.89717 8.50637 2.9845C8.81728 3.03458 9.18874 3.26048 9.35758 3.52132C9.5928 3.88346 9.2982 4.21068 9.00359 4.45754C8.58788 4.80571 8.17915 5.1632 7.74015 5.47993C7.45603 5.68371 7.38383 5.88051 7.50843 6.21237C7.71104 6.75035 7.8403 7.31628 8.04757 7.85309C8.20826 8.2723 8.16751 8.61348 7.81351 8.88596C7.47233 9.14797 7.13813 9.07111 6.80044 8.83589C6.32534 8.50519 5.81414 8.22572 5.35418 7.87638C4.99786 7.60506 4.73819 7.62369 4.38769 7.90084C3.90327 8.28394 3.37927 8.62396 2.84245 8.92905C2.26256 9.25976 1.62909 8.89877 1.63841 8.18263Z",
    fill: "#FCB040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.f3bfc1baeb92312331aedf0e38b4277e.svg";
export { ForwardRef as ReactComponent };